import React from 'react';
import { Container, Row, Col } from 'mdbreact';
import Lightbox from 'react-image-lightbox';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';

import drawing_a_new_life from 'assets/drawings/drawing_a_new_life.jpg';
import drawing_chenonceau_towers from 'assets/drawings/drawing_chenonceau_towers.jpg';
import drawing_galerie_st_paul from 'assets/drawings/drawing_galerie_st_paul.jpg';
import drawing_materials_study from 'assets/drawings/drawing_materials_study.jpg';
import drawing_new_room from 'assets/drawings/drawing_new_room.jpg';
import drawing_ocean from 'assets/drawings/drawing_ocean.jpg';
import drawing_constructivism from 'assets/drawings/drawing_constructivism.jpg';
import drawing_lake_huron from 'assets/drawings/drawing_lake_huron.jpg';
import drawing_dent_de_crolles from 'assets/drawings/drawing_dent_de_crolles.png';

import thumb_a_new_life from 'assets/drawings/thumb_a_new_life.jpg';
import thumb_chenonceau_towers from 'assets/drawings/thumb_chenonceau_towers.jpg';
import thumb_galerie_st_paul from 'assets/drawings/thumb_galerie_st_paul.jpg';
import thumb_materials_study from 'assets/drawings/thumb_materials_study.jpg';
import thumb_new_room from 'assets/drawings/thumb_new_room.jpg';
import thumb_ocean from 'assets/drawings/thumb_ocean.jpg';
import thumb_constructivism from 'assets/drawings/thumb_constructivism.jpg';
import thumb_lake_huron from 'assets/drawings/thumb_lake_huron.jpg';
import thumb_dent_de_crolles from 'assets/drawings/thumb_dent_de_crolles.jpg';


require('mdbreact/docs/pages/pro/Lightbox.css');


const images = [
  { asset_image: drawing_a_new_life,
    asset_thumb: thumb_a_new_life,
    title: 'A new life'
  },
  { asset_image: drawing_chenonceau_towers,
    asset_thumb: thumb_chenonceau_towers,
    title: 'Chenonceau towers'
  },
  { asset_image: drawing_galerie_st_paul,
    asset_thumb: thumb_galerie_st_paul,
    title: 'Galerie St Paul'
  },
  { asset_image: drawing_materials_study,
    asset_thumb: thumb_materials_study,
    title: 'Materials study'
  },
  { asset_image: drawing_constructivism,
    asset_thumb: thumb_constructivism,
    title: 'The spirit of constructivism'
  },
  { asset_image: drawing_lake_huron,
    asset_thumb: thumb_lake_huron,
    title: 'Lake Huron'
  },
  { asset_image: drawing_dent_de_crolles,
    asset_thumb: thumb_dent_de_crolles,
    title: 'Dent de Crolles'
  },
  { asset_image: drawing_new_room,
    asset_thumb: thumb_new_room,
    title: 'New Room'
  },
  { asset_image: drawing_ocean,
    asset_thumb: thumb_ocean,
    title: 'Ocean'
  }
];


class PageDrawing extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      photoIndex: 0,
      isAssetOpened: false
    };
  }

  static get propTypes() {
    return {
      propTitle: PropTypes.string,
      onActivated: PropTypes.func
    };
  }

  componentDidMount() {
    console.log(`PageDrawing::componentDidMount with props: ${this.props}`);
    console.log(this.props);
    this.props.onActivated(this.props.propTitle);
  }

  render() {
    const { photoIndex, isAssetOpened } = this.state;
    return (
      <Container className="mt-5">
        <div className="mdb-lightbox no-margin">
          <Row>
            <Col md="4">
              <figure>
                <img src={images[0].asset_thumb} alt="Gallery" className="img-fluid" onClick={() => this.setState({ photoIndex: 0, isAssetOpened: true })} />
              </figure>
            </Col>
            <Col md="4">
              <figure>
                <img src={images[1].asset_thumb} alt="Gallery" className="img-fluid" onClick={() => this.setState({ photoIndex: 1, isAssetOpened: true })} />
              </figure>
            </Col>
            <Col md="4">
              <figure>
                <img src={images[2].asset_thumb} alt="Gallery" className="img-fluid" onClick={() => this.setState({ photoIndex: 2, isAssetOpened: true })} />
              </figure>
            </Col>
            <Col md="4">
              <figure>
                <img src={images[3].asset_thumb} alt="Gallery" className="img-fluid" onClick={() => this.setState({ photoIndex: 3, isAssetOpened: true })} />
              </figure>
            </Col>
            <Col md="4">
              <figure>
                <img src={images[4].asset_thumb} alt="Gallery" className="img-fluid" onClick={() => this.setState({ photoIndex: 4, isAssetOpened: true })} />
              </figure>
            </Col>
            <Col md="4">
              <figure>
                <img src={images[5].asset_thumb} alt="Gallery" className="img-fluid" onClick={() => this.setState({ photoIndex: 5, isAssetOpened: true })} />
              </figure>
            </Col>
            <Col md="4">
              <figure>
                <img src={images[6].asset_thumb} alt="Gallery" className="img-fluid" onClick={() => this.setState({ photoIndex: 6, isAssetOpened: true })} />
              </figure>
            </Col>
            <Col md="4">
              <figure>
                <img src={images[7].asset_thumb} alt="Gallery" className="img-fluid" onClick={() => this.setState({ photoIndex: 7, isAssetOpened: true })} />
              </figure>
            </Col>
            <Col md="4">
              <figure>
                <img src={images[8].asset_thumb} alt="Gallery" className="img-fluid" onClick={() => this.setState({ photoIndex: 8, isAssetOpened: true })} />
              </figure>
            </Col>
          </Row>
        </div>
        {isAssetOpened && (
          <Lightbox
            mainSrc={images[photoIndex].asset_image}
            nextSrc={images[(photoIndex + 1) % images.length].asset_image}
            prevSrc={images[(photoIndex + images.length - 1) % images.length].asset_image}
            imageTitle={images[photoIndex].title}
            // imagePadding={500}
            onCloseRequest={() => this.setState({ isAssetOpened: false })}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex: (photoIndex + images.length - 1) % images.length
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % images.length
              })
            }
          />
        )}
      </Container>
    );
  }
}

export default withRouter(PageDrawing);



// WEBPACK FOOTER //
// ./src/Pages/Drawing/page-drawing.js